import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, TouchableOpacity } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  focused: boolean;
  icon: React.ReactNode;
  numberOfLines?: number;
  onPress: () => void;
  testID: string;
  title?: string;
}

export const SideNavButton: React.FC<Props> = ({
  focused,
  icon,
  numberOfLines,
  onPress,
  testID,
  title,
}) => {
  const [styles] = useStyles();

  return (
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityState={{ selected: focused }}
      onPress={onPress}
      style={[styles.iconWrapper, focused ? styles.iconWrapperFocused : null]}
      testID={testID}
    >
      {icon}
      {title ? (
        <Text
          ellipsizeMode="tail"
          numberOfLines={numberOfLines}
          style={[
            TYPOGRAPHY.tiny,
            styles.title,
            focused ? styles.titleActive : null,
          ]}
        >
          {title}
        </Text>
      ) : null}
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  iconWrapper: {
    alignItems: 'center',
    backgroundColor: theme.colors.accent,
    height: 70,
    justifyContent: 'center',
  },
  iconWrapperFocused: {
    backgroundColor: theme.colors.white,
  },
  title: {
    color: theme.colors.accentText,
    textAlign: 'center',
  },
  titleActive: {
    color: theme.colors.primary,
  },
}));
